import { FaCar } from "react-icons/fa";

interface CarroProps {
  acao: () => void;
}
export function Carro({ acao }: CarroProps) {
  return <FaCar style={{ cursor: "pointer" }} onClick={acao} />;
}
